/**
 * CrewIdentityModal — Standalone wrapper around CrewIdentityEditor.
 * iter84.24.
 *
 * Single-purpose modal so crewmates in BOTH single-tournament and
 * multi-tournament Rivalries can reach the avatar / flair editor in
 * one click from the dashboard header. Single-tournament users can
 * still use the inline editor inside YourTinyCrewModal; this is the
 * universal entry point that works regardless of tournament count.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";
import CrewIdentityEditor from "@/components/CrewIdentityEditor";


export default function CrewIdentityModal({ open, onOpenChange, participantId, currentAvatar, currentFlair, onSaved }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="crew-identity-modal"
                className="max-w-md bg-ink border-2 border-cyber/40 max-h-[80dvh] overflow-y-auto"
            >
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 font-display font-extrabold uppercase text-cyber">
                        <Sparkles className="w-5 h-5" /> Your Crew Identity
                    </DialogTitle>
                    <DialogDescription className="text-xs text-zinc-400 leading-relaxed">
                        Pick an avatar emoji and a one-line flair — your crewmates will see them on the leaderboard, roster, and Smack Stream.
                    </DialogDescription>
                </DialogHeader>
                <CrewIdentityEditor
                    participantId={participantId}
                    initialAvatar={currentAvatar}
                    initialFlair={currentFlair}
                    onSaved={onSaved}
                />
            </DialogContent>
        </Dialog>
    );
}
